export default "__VITE_ASSET__CjRUkBK0__"